<template>
  <div>
    <div class="grade__item mb-4" v-for="(g, i) in descriptors" :key="i + key">
      <div class="input-group mt-2">
        <h6 class="d-block w-100 mb-1" for="">
          {{ descriptors[i].name }} (<strong
            v-for="t in descriptors[i].types"
            :key="t"
            >[{{ t }}]</strong
          >)
        </h6>
        <small
          style="color: #666; font-size: 13px"
          v-html="descriptors[i].description"
        ></small>
      </div>
      <hr />
    </div>
    <div class="d-flex justify-content-end pt-2 d-none">
      <b-button @click="addStep" variant="link"> + Додати крок </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["descriptorsInput"],
  data() {
    return {
      key: 1,
      new_descriptor: {
        description: "",
        name: "",
      },
      descriptors: [],
    };
  },
  watch: {
    descriptorsInput: {
      handler() {
        if (this.descriptorsInput) {
          this.descriptors = this.descriptorsInput;
          this.key++;
        }
      },
    },
  },
  methods: {
    addStep() {
      let grade = Object.assign({}, this.new_descriptor);

      this.descriptors.push(grade);
    },
  },
  mounted() {
    if (this.descriptorsInput) {
      this.descriptors = this.descriptorsInput;
      this.key++;
    }
  },
};
</script>

<style lang="scss" scoped>
.grade {
  &__item {
  }
}
</style>
